import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { FsaSourcedCompanyDetailModel } from '../../Models/Models/Company/FsaSourcedCompanyDetailModel';

declare var IS_RUNNING_IN_APP_POOL;

export class FsaSourcedCompanyDetailsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(fsaNumber: string): Promise<FsaSourcedCompanyDetailModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Company/FsaSourcedCompanyDetails/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { fsaNumber: fsaNumber }

    return AjaxWrapper.get<FsaSourcedCompanyDetailModel, any>(url, data);
  }
}

